import React from 'react';
import PropTypes from 'prop-types';

const Student = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill={color}
      d="m19.45 18.6-4.462-1.152c.797-.648 1.355-1.44 1.514-2.448.558-.144.956-.72.956-1.44 0-.216-.08-.432-.08-.576l.399-2.808c0-.072.16-1.44-1.036-2.664C15.785 6.504 14.111 6 11.961 6c-2.152 0-3.746.504-4.782 1.512-1.195 1.152-1.036 2.592-1.036 2.664l.399 2.808c-.08.144-.08.36-.08.576 0 .72.399 1.224.956 1.44.08 1.008.717 1.872 1.594 2.52L4.39 18.6C2.956 19.104 2 20.328 2 21.768v1.872c0 .216.16.36.398.36H21.602c.239 0 .398-.144.398-.36v-1.872c-.08-1.44-1.036-2.664-2.55-3.168ZM7.737 8.016c.877-.864 2.31-1.296 4.223-1.296 1.912 0 3.347.432 4.144 1.224.956.936.796 2.088.796 2.088l-.318 2.16c-.08 0-.16-.072-.24-.072l-.398-1.656c0-.144-.239-.288-.398-.288-2.47 0-2.948-.648-3.187-1.08.08-.072 0-.216-.08-.288a.414.414 0 0 0-.558 0c-.16.072-.239.216-.319.36-.239.432-.717 1.08-3.187 1.08-.16-.072-.319.072-.398.216l-.319 1.656c-.08 0-.16.072-.239.072l-.319-2.16s-.08-1.08.797-2.016Zm.478 6.624c0-.216-.16-.36-.398-.36-.399 0-.558-.504-.558-.792 0-.288.08-.792.558-.792.16 0 .318-.144.398-.288l.319-1.584c2.23 0 2.948-.504 3.426-1.152.478.648 1.195 1.152 3.426 1.224l.32 1.584c0 .144.238.288.398.288.398 0 .557.504.557.792 0 .288-.08.792-.557.792-.24 0-.399.144-.399.36 0 1.08-.797 1.944-1.673 2.592-.08 0-.24.072-.319.144-.637.432-1.354.648-1.832.648-.399 0-1.116-.216-1.754-.576-.08-.072-.159-.072-.239-.144-.876-.648-1.673-1.584-1.673-2.736Zm3.745 5.256c-.478 0-.876-.36-.876-.792V18.6c.318.072.637.144.876.144.24 0 .558-.072.877-.144v.504c0 .432-.399.792-.877.792Zm-9.163 1.872c0-1.152.717-2.088 1.832-2.52l5.1-1.224c.16.072.319.216.558.288v.864c0 .576.398 1.152.956 1.368L9.251 23.28H2.797v-1.512Zm7.41 1.512 1.753-2.376 1.753 2.376h-3.506Zm10.916 0H14.67l-1.036-1.404-1.035-1.404c.557-.216.956-.792.956-1.368v-.864c.239-.072.398-.216.637-.36l4.94 1.296c1.196.36 1.913 1.368 1.913 2.52v1.584h.08Z"
    />
    <path
      fill={color}
      d="M9.481 12.667h.815c0 .2.148.333.37.333.223 0 .445-.2.445-.333C11.11 12 10.37 12 10 12c-.37 0-1.111 0-1.111.667 0 .2.148.333.37.333.074 0 .222-.133.222-.333ZM12.868 13c.22 0 .368-.133.368-.333H14.043c0 .2.147.333.368.333.22 0 .367-.133.367-.333 0-.667-.735-.667-1.102-.667-.367 0-1.101 0-1.101.667-.074.133.073.333.293.333Z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.9}
      d="M20 3.75 16.16 5.5 12 4.5l-4 .875L4 3.75 12 .5l8 3.25Z"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.8}
      d="M17.715 7.5C17.715 5.843 14.603 5 12 5c-2.602 0-5.714.843-5.714 2.5"
    />
    <path stroke={color} strokeLinecap="square" strokeWidth={0.4} d="M19.429 3.5v2.9" />
    <path
      fill={color}
      d="M19.24 6.57a.2.2 0 0 1 .38 0l.722 2.167a.2.2 0 0 1-.19.263h-1.444a.2.2 0 0 1-.19-.263l.722-2.168Z"
    />
  </svg>
);

Student.propTypes = {
  color: PropTypes.string
};

export default Student;
